var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "800px",
    height: "800px",
    fill: "#000000",
    viewBox: "-102.5 -102.5 1230 1230",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 576.57m-431.45 0a431.45 431.45 0 1 0 862.9 0 431.45 431.45 0 1 0-862.9 0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 1024c-246.88 0-447.43-200.54-447.43-447.43s200.54-447.43 447.43-447.43 447.43 200.54 447.43 447.43-200.54 447.43-447.43 447.43zm0-862.9c-229.31 0-415.47 186.16-415.47 415.47s186.16 415.47 415.47 415.47 415.47-186.16 415.47-415.47-186.16-415.47-415.47-415.47z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 576.57m-324.38 0a324.38 324.38 0 1 0 648.77 0 324.38 324.38 0 1 0-648.77 0z",
    fill: "#F86C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 917.74c-187.76 0-340.36-152.6-340.36-340.36s152.6-340.36 340.36-340.36 340.36 152.6 340.36 340.36-152.6 340.36-340.36 340.36zm0-649.57c-170.18 0-308.41 138.22-308.41 308.41s138.22 308.41 308.41 308.41 308.41-138.22 308.41-308.41-138.22-308.41-308.41-308.41z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 576.57m-208.53 0a208.53 208.53 0 1 0 417.07 0 208.53 208.53 0 1 0-417.07 0z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 801.88c-123.84 0-224.51-100.67-224.51-224.51s100.67-225.31 224.51-225.31 224.51 100.67 224.51 224.51-100.67 225.31-224.51 225.31zm0-417.87c-106.26 0-192.55 86.29-192.55 192.55s86.29 192.55 192.55 192.55 192.55-86.29 192.55-192.55-86.29-192.55-192.55-192.55z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 576.57m-101.47 0a101.47 101.47 0 1 0 202.94 0 101.47 101.47 0 1 0-202.94 0z",
    fill: "#F86C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m447.43 694.02c-64.717 0-117.45-52.733-117.45-117.45s52.733-117.45 117.45-117.45 117.45 52.733 117.45 117.45c0 65.516-52.733 117.45-117.45 117.45zm0-202.14c-47.14 0-85.491 38.351-85.491 85.491s38.351 84.692 85.491 84.692 85.491-38.351 85.491-85.491-38.351-84.692-85.491-84.692z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m1008.3 114.76-129.43 128.64-100.67 2.3969 2.3969-100.67 129.43-128.64-3.9949 102.27z",
    fill: "#C2CDDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m779 261.78c-3.9949 0-7.9898-1.598-11.186-4.7939-3.1959-3.1959-4.7939-7.1908-4.7939-11.985l2.3969-100.67c0-3.9949 1.598-7.9898 4.7939-11.186l129.43-128.64c4.7939-4.7939 11.985-5.5928 17.578-3.1959 6.3918 2.3969 9.5877 8.7888 9.5877 15.181l-3.1959 84.692 84.692-3.1959c6.3918 0 12.784 3.1959 15.181 9.5877s1.598 12.784-3.1959 17.578l-129.43 128.64c-3.1959 3.1959-7.1908 4.7939-11.186 4.7939l-100.67 3.1959zm17.578-109.46-1.598 77.501 77.501-1.598 95.877-95.877-61.521 2.3969c-4.7939 0-8.7888-1.598-11.985-4.7939s-4.7939-7.1908-4.7939-11.985l2.3969-61.521-95.877 95.877z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m455.42 580.57c-3.9949 0-7.9898-1.598-11.186-4.7939-6.3918-6.3918-6.3918-15.98 0-22.371l525.73-525.73c6.3918-6.3918 15.98-6.3918 22.371 0s6.3918 15.98 0 22.371l-525.73 525.73c-3.1959 3.1959-7.1908 4.7939-11.186 4.7939z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m942.79 188.27h-95.078c-8.7888 0-15.98-7.1908-15.98-15.98v-93.48c0-8.7888 7.1908-15.98 15.98-15.98s15.98 7.1908 15.98 15.98v77.501h79.099c8.7888 0 15.98 7.1908 15.98 15.98s-7.1908 15.98-15.98 15.98z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.f4f75c7b9f2dc8ddb4ce90090cf6235b.svg";
export { ForwardRef as ReactComponent };